import React, { useEffect } from 'react'
import { useQuery, useLazyQuery } from '@apollo/react-hooks'
import { coursesQueries, modulesQueries } from '../../graphql/queries'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import CardsGrid from './CardsGrid'
import GridItem from './GridItem'
import CardCourse from './CardCourse'
import LoadingCourses from './LoadingCourses'
import CoursesError from '../CoursesError'
import CardPlaceholder from './CardPlaceholder'
import * as API from '../../api'
import * as authService from '../../services/auth'


const useStyles = makeStyles({
  pageTitle: {
    margin: '0 1.5%',
    fontSize: '32px',
    marginTop: '45px'
  }
})

const CoursesList = () => {


  API.auth
        .getCourses({
          usu_id:authService.getUserId()         
        })
        .then(response => {
          const { ok, status } = response

          if (ok) {
            response
            .json()
            .then(data => {
              const { token } = data           
              authService.updateToken(token)              
            })
            .catch(err => {
              console.log(err)
            })
          }
        })
        .catch(err => {
         console.log(err)
        })

  const classes = useStyles()

  const { loading, error, data, refetch } = useQuery(coursesQueries.GET_COURSES)

  const [loadModule, { loading: loadingModule, data: modulo }] = useLazyQuery(modulesQueries.GET_MODULES, { fetchPolicy: "network-only" })

  useEffect(() => {
    loadModule()
  }, [])  // eslint-disable-line

  if (loading || loadingModule || !modulo) return <LoadingCourses />
  if (error) return <CoursesError refresh={refetch} />

  return (
    <>
      <Typography gutterBottom variant="h5" component="h2" className={classes.pageTitle} color={'primary'}>
        Meus cursos
      </Typography>
      <CardsGrid>
        {(data.cursos.length && data.cursos !== undefined) ? data.cursos.map((card, key) => (
          <GridItem cardsQuantity={data.cursos.length} index={key}>
            <CardCourse item={card} index={key} isUserCourse={true} />
          </GridItem>
        )) :
          <GridItem isPlaceholder={true}>
            <CardPlaceholder />
          </GridItem>
        }
      </CardsGrid>
      {/* Lista de cursos disponíveis
      <Typography gutterBottom variant="h5" component="h2" className={classes.pageTitle} color={'primary'}>
        Todos os cursos
      </Typography>
      <CardsGrid>
        {data.cursos.map((card, key) => (
          <GridItem>
            <CardCourse item={card} index={key} isUserCourse={false}/>
          </GridItem>
        ))}
      </CardsGrid> */}
    </>
  )
}

export default CoursesList
